import { POSITIONS_SIDE } from '../constants';

function isPositionBuy(traderDirection: number) {
  return traderDirection === POSITIONS_SIDE.buy;
}

export { isPositionBuy };
